'use strict';

angular.module('onboarding.common.security',
	[
	]);
